import Div100vh from "react-div-100vh"
import { Link } from "react-router-dom"
import overviewImg from "./overview.png"
import mapIcon from "./map.svg"
import exploreIcon from "../Location/images/square.svg"
import "./Overview.css"
import { useStore } from "../../components/ApartmentFinder/State/Store"

const Overview = () => {
  const loaded = useStore(state => state.loaded)
  const setApartmentFinderActive = useStore(
    state => state.setApartmentFinderActive
  )
  const setCurrentCameraPositionID = useStore(
    state => state.setCurrentCameraPositionID
  )

  const handleClick = () => {
    setApartmentFinderActive(false)
    setCurrentCameraPositionID("wide")
  }

  return (
    <Div100vh className="overview-screen">
      <img src={overviewImg} alt="" className="background" />
      <Link to="/location/" className="map-icon">
        <img src={mapIcon} alt="Location" />
      </Link>
      <Link to="/explore/" className="explore-icon">
        {loaded === true && (
          <img onClick={() => handleClick()} src={exploreIcon} alt="Explore" />
        )}
      </Link>
    </Div100vh>
  )
}

export default Overview
